(function () {
    'use strict';
    radaSearchController.$inject = ['searchService'];
    angular 
        .module("app.search")
        .component("radaSearch", {
            controller: radaSearchController,
            bindings: {
                searchPlaceholder: '@',
                pageId: '@',
                searchDescription: '@',
                searchNoResults: '@',
                searchPages: '@',
                searchProducts: '@'
            }, // components are limited to isolated scope
            templateUrl: "/client/app/search/search.html",
            controllerAs: 'vm'
        });

    /* @ngInject */
    function radaSearchController(searchService) {
        var vm = this;
        vm.submitted = false;
        vm.term = "";
        vm.results = {};
        vm.results.pageNumber = 1;
        
        vm.$onInit=function() {
            vm.model = {};
        };

        vm.submit=function () {
            searchService.search(vm.pageId, vm.term, 1).then(function(resp) {
                if (resp) {
                    vm.results = resp;
                    vm.pages = [];
                    for (var i = vm.results.legendMin ; i <=  vm.results.legendMax; i++) {
                        vm.pages.push(i);
                    }
                }
            });
        }

        vm.next= function () {
            vm.results.pageNumber++;
            if (vm.results.pageNumber>vm.results.pageNumber) {
                vm.results.pageNumber = vm.results.pageTotal;
            }
            searchService.search(vm.pageId, vm.term, vm.results.pageNumber).then(function(resp) {
                if (resp) {
                    vm.results = resp;
                    vm.pages = [];
                    for (var i = vm.results.legendMin ; i <=  vm.results.legendMax; i++) {
                        vm.pages.push(i);
                    }

                }
            });
        }

        vm.previous=function() {
            vm.results.pageNumber--;
            if (vm.results.pageNumber<1)
            {
                vm.results.pageNumber = 1;
            }
            searchService.search(vm.pageId, vm.term, vm.results.pageNumber).then(function(resp) {
                if (resp) {
                    vm.results = resp;
                    vm.pages = [];
                    for (var i = vm.results.legendMin ; i <=  vm.results.legendMax; i++) {
                        vm.pages.push(i);
                    }
                }
            });
        }

        vm.changePageNumber = function (pageNumber) {
            vm.results.pageNumber = pageNumber;
            searchService.search(vm.pageId, vm.term, vm.results.pageNumber).then(function(resp) {
                if (resp) {
                    vm.results = resp;
                    vm.pages = [];
                    for (var i = vm.results.legendMin ; i <=  vm.results.legendMax; i++) {
                        vm.pages.push(i);
                    }
                }
            });
        }





    }}
)();